import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const IM_DEFAULT = { key: "italiamobile", name: "Italia Mobile", kind: "sim", logo: "/operators/italiamobile.png", active: true, features: {} };
export const DEFAULT_LOGOS = { italiamobile: "/operators/italiamobile.png", emobile24: "/operators/emobile24.png", unomobile: "/operators/unomobile.svg", simamma: "/operators/simamma.png" };
export const OperatorContext = createContext(IM_DEFAULT);
export const useOperator = () => useContext(OperatorContext);

let cache = null;
export const useOperators = () => {
  const [items, setItems] = useState(cache);
  useEffect(() => {
    const load = () => api.get("/mobile-operators").then((r) => { cache = r.data.items || []; setItems(cache); }).catch(() => setItems((v) => v || []));
    load();
    window.addEventListener("operators-changed", load);
    return () => { window.removeEventListener("operators-changed", load); };
  }, []);
  return items;
};
